var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('HeroMercados',{attrs:{"data":_vm.bannermercado}}),_c('div',{staticClass:"container"},[_c('CardsWallPapers',{attrs:{"onlytitle":true,"data":this.cards}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }